/**
 * @generated SignedSource<<12f5f476199e6734d50fcfc1d4abbaa6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreEditNameScreenQuery$variables = Record<PropertyKey, never>;
export type StoreEditNameScreenQuery$data = {
  readonly store: {
    readonly name: string;
  };
};
export type StoreEditNameScreenQuery = {
  response: StoreEditNameScreenQuery$data;
  variables: StoreEditNameScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreEditNameScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StoreEditNameScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff6bca18e05933fc478078102755eec5",
    "id": null,
    "metadata": {},
    "name": "StoreEditNameScreenQuery",
    "operationKind": "query",
    "text": "query StoreEditNameScreenQuery {\n  store {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "240208c7e4b6fb5bbcf68b36e27646bf";

export default node;
